'use client';

import { MultipleUploader } from '@/components/batchToolsComp/LandingPageIntroUpload/MultipleUploader';
import { useImageProcessing } from '../context/ImageProcessingContext';
import useImageUploader from '../useHook/useImageUploader';
import useReportPoints from '../useHook/useReportPoints';
import { useCallback } from 'react';
import { BATCH_REPAIR_IMG_UPLOAD_MAX_IMAGE_COUNT } from '@/constants';

interface UploadWrapperProps {
  nextPageUrlParams?: string;
}

export default function UploadWrapper({
  nextPageUrlParams,
}: UploadWrapperProps) {
  const { clearImages } = useImageProcessing();
  const { handleImageUploadInit } = useImageUploader({ from: 'landingPage' });
  const { batch_RP_after_select } = useReportPoints();

  const onImagesUpload = useCallback(
    async (files: FileList) => {
      await handleImageUploadInit(files);
      batch_RP_after_select({
        before_counts: 0,
        single_counts: files.length,
        over_limit_counts:
          files.length - BATCH_REPAIR_IMG_UPLOAD_MAX_IMAGE_COUNT,
      });
    },
    [batch_RP_after_select, handleImageUploadInit]
  );

  return (
    <MultipleUploader
      maxImageCount={BATCH_REPAIR_IMG_UPLOAD_MAX_IMAGE_COUNT}
      nextPageUrlParams={nextPageUrlParams}
      asyncBeforeUpload={() => clearImages()}
      onImagesUpload={onImagesUpload}
    />
  );
}
